import { configureStore } from '@reduxjs/toolkit';

import accountSlice from './account.slice';
import authSlice from './auth.slice';
import ordersSlice from '../pages/OrdersPage/slice/orders.slice';
import notesSlice from '../pages/NotesPage/slice/notes.slice';
import controlSlice from '../pages/ControlPage/slice/control.slice';
import requestsSlice from '../pages/RequestsPage/requests.slice';
import clientsSlice from './clients.slice';
import helpersSlice from './helpers.slice';
import productsSlice from './products.slice';
import vendorsSlice from './vendors.slice';
import meSlice from './me.slice';
import partnersSlice from './partners.slice';
import couriersSlice from './couriers.slice';
import bannerSlice from './banner.slice';
import promotionSlice from './promotion.slice';
import smsSlice from './sms.slice';

export const store = configureStore({
  reducer: {
    account: accountSlice,
    auth: authSlice,
    orders: ordersSlice,
    notes: notesSlice,
    control: controlSlice,
    requests: requestsSlice,
    clients: clientsSlice,
    helpers: helpersSlice,
    products: productsSlice,
    vendors: vendorsSlice,
    me: meSlice,
    partners: partnersSlice,
    couriers: couriersSlice,
    banner: bannerSlice,
    promotion: promotionSlice,
    sms: smsSlice,
  },
  devTools: process.env.NODE_ENV !== 'production' ? {} : false,
});
